module.exports = __webpack_public_path__ + "static/media/page-2.8e4ca013.png";